import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ selectedContentType: any }>;

export const DispatchSetSelectedContentTab: HandlerType = props => {
    props.dispatch({
        type: "Custom/Article/SetSelectedContentType",
        selectedContentType: props.parameter.selectedContentType,
    });
};

export const chain = [DispatchSetSelectedContentTab];

const CENSetSelectedContentTab = createHandlerChainRunner(chain, "CENSetSelectedContentTab");
export default CENSetSelectedContentTab;
